import React, { ReactNode } from 'react'
import { Button } from '@systemeio/components'
import { useTranslation } from 'next-i18next'
import { twJoin } from 'tailwind-merge'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useGetCoursePageUrl } from 'modules/course/hooks/use-course-path-url'
import useStepRouter from 'modules/course/hooks/use-step-router'
import { CourseQuizId } from 'modules/course/types/course-quiz-interface'
import { CourseStepEnum } from 'modules/course/types/course-step-type'
import { addPublicCustomClassNamePrefix } from 'modules/course/utils/add-class-prefix'
import { CourseInfoScreenLayout } from './course-info-screen-layout'

interface CourseNeedCompleteModuleScreenProps {
  blockingStep?: CourseQuizId
}

export const CourseNeedCompleteModuleScreen = ({
  blockingStep,
}: React.PropsWithChildren<CourseNeedCompleteModuleScreenProps>): ReactNode => {
  const { t } = useTranslation()

  const coursePath = useGetCoursePageUrl()

  const { findStepById, findStep, step: currentStep } = useStepRouter()

  let step = findStepById(blockingStep)

  if (!step?.available) {
    step = findStep()
  }

  const message =
    currentStep?.type === CourseStepEnum.quiz
      ? 'course.quiz.complete_all_lectures_message'
      : 'course.quiz.complete_previous_module_message'
  const cta =
    currentStep?.type === CourseStepEnum.quiz
      ? 'course.quiz.go_to_uncompleted_lecture_button'
      : 'course.quiz.go_to_uncompleted_module_button'

  return (
    <CourseInfoScreenLayout
      className={addPublicCustomClassNamePrefix(`course__info-screen--need-to-complete-module`)}
      text={t(message)}
      buttons={
        <Button
          variant="primary"
          className={twJoin(
            'bg-THEME-secondary! text-THEME-block-background! hover:bg-THEME-hover-secondary! hover:text-THEME-block-background! disabled:border-THEME-disabled! disabled:bg-THEME-disabled!',
            `font-bold`,
            addPublicCustomClassNamePrefix([
              'course__button',
              'course__button--primary',
              'course__button--go-to-uncompleted-module',
            ]),
          )}
          render={
            <LinkWithoutPrefetch href={`/school/course/${coursePath}/${step?.type}/${step?.id}`} />
          }
        >
          {t(cta)}
        </Button>
      }
    />
  )
}
